<template>
  <div class="main">
    <div class="title">账号列表</div>
    <search class="search" :searchForm="searchForm" :searchList="searchList" :optionsType="optionsType" :isAccount="1"></search>
    <!--    表格-->
    <div class="add-button" @click="addAccount">新增账号</div>
    <el-table
      class="table"
      v-loading="searchForm.Loading"
      :data="tableList.list"
      border
      fit
      highlight-current-row
      style="width: 100%;"
      header-row-class-name="header"
    >
      <el-table-column
        v-for="(item,index) in tableData"
        :key="index"
        :prop="item.value"
        :label="item.text"
        align="center"
      >
        <template slot-scope="{row}">
          <el-switch
            v-if="item.value === 'status'"
            v-model="row[item.value]"
            :active-value="1"
            :inactive-value="3"
            active-color="#13ce66"
            inactive-color="#ff4949"
          @change="changeSwitch($event,row.id)">
          </el-switch>
          <span v-else>{{ row[item.value] }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="操作">
        <template slot-scope="{row}">
          <span class="delete" @click="deleteShow(row.id)">删除账号</span>
        </template>
      </el-table-column>
    </el-table>
    <!--    分页-->
    <el-pagination
      v-if="tableList.total > 0"
      class="pagination"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="tableList.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="tableList.total">
    </el-pagination>
    <el-dialog
      title="新增账号"
      :visible.sync="dialogVisible"
      width="40%"
      :before-close="handleClose">
      <div class="dialog">
        <div class="flex">
          <div class="input-text">手机号码</div>
          <input class="input" v-model="subMobile" type="number" placeholder="请输入手机号码">
        </div>
        <div class="flex">
          <div class="input-text">用户名</div>
          <input class="input" autocomplete="new-password" v-model="nickname" type="text" placeholder="请输入用户名">
        </div>
        <!--        <div class="flex">-->
        <!--          <div class="input-text">验证码</div>-->
        <!--          <div style="display: flex">-->
        <!--            <input class="input" v-model="code" type="number" placeholder="请输入验证码">-->
        <!--            <div v-show="!showCountDown" class="code-btn" @click="getCode">-->
        <!--              获取验证码-->
        <!--            </div>-->
        <!--            <div v-show="showCountDown" class="clock-btn">-->
        <!--              重新发送({{countDown}})s-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->
        <div class="flex">
          <div class="input-text">密码</div>
          <input class="input" autocomplete="new-password" v-model="password" type="password" placeholder="请输入密码">
        </div>
        <div class="flex">
          <div class="input-text">确认密码</div>
          <input class="input" autocomplete="new-password" v-model="repeatPassword" type="password" placeholder="请输入密码">
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="addNumber()">确 定</el-button>
  </span>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="deleteDialog"
      width="30%"
      :before-close="handleClose">
      <span>确定删除账号？</span>
      <span slot="footer" class="dialog-footer">
    <el-button @click="deleteDialog = false">取 消</el-button>
    <el-button type="primary" @click="deleteAccount">确 定</el-button>
  </span>
    </el-dialog>

  </div>
</template>

<script>
import search from "@/components/Search";
import {registerSms} from '@/api/user'
import mini from '@/api/mini'

const MiniModel = new mini()
export default {
  name: "index",
  components: {
    search
  },
  data() {
    return {
      searchForm: {
        nickname: '',
        mobile: '',
        status: '',
        pageSize: 10,
        pageNo: 1,
        total: '',
        // appKey:localStorage.getItem('appKeyMini'),
        Loading: true
      },
      searchList: [
        {
          id: 'nickname',
          text: '用户名',
          placeholder: '请输入用户名',
          type: 'input'
        }, {
          id: 'mobile',
          text: '手机号',
          placeholder: '请输入手机号',
          type: 'input'
        }, {
          id: 'status',
          text: '状态',
          placeholder: '请选择',
          type: 'select'
        }],
      // 表头
    // {
    //   text: 'uuid',
    //     value: 'userUUID',
    // },
    tableData: [
        {
          text: '用户名',
          value: 'nickname',
        }, {
          text: '手机号',
          value: 'mobile',
        }, {
          text: '状态',
          value: 'status',
        }
      ],
      tableList: [],
      currentPage: 1,
      dialogVisible: false,
      showCountDown: false,//显示倒计时
      countDown: 60,  //倒计时
      timer: null,
      subMobile: '',
      password: '',
      repeatPassword: '',
      nickname: '',
      id:'', // 当前id
      deleteDialog:false, // 删除弹窗
      optionsType:[{
        label:'开启',
        value:1
      },{
        label:'关闭',
        value:3
      }],
    }
  },
  destroyed() {
    this.timer = null
  },
  mounted() {
    this.getList()
  },
  methods: {
    handleSizeChange(e) {
      this.searchForm.pageSize = e
      this.getList()
    },
    handleCurrentChange(e) {
      this.searchForm.pageNo = e
      this.getList()
    },
    handleClose() {
      this.dialogVisible = false
    },
    // 新增账号
    addAccount() {
      this.dialogVisible = true
      this.subMobile = ''
      this.password = ''
      this.repeatPassword = ''
      this.nickname = ''
    },
    isMobile: function(value) {
      return /^1[3|4|5|6|7|8|9][0-9]\d{8}$/.test(value);                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      return /^(https?|ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i.test(value);
    },
    // getCode(){
    //   this.showCountDown = true
    //   MiniModel.getCode({
    //     // nickname:this.subMobile,
    //     mobile: this.subMobile,
    //   }).then(response => {
    //     this.$Message.success(response.message)
    //     this.timer = setInterval(()=>{
    //       this.countDown--
    //       if(this.countDown === 0){
    //         this.showCountDown = false
    //         this.countDown = 60;
    //         clearInterval(this.timer)
    //       }
    //     },1000)
    //   }).catch(error => {
    //     console.log(error)
    //     this.showCountDown = false
    //   })
    // },
    // 新增账号
    addNumber() {
      if(!this.isMobile(this.subMobile)){
        this.$message.error('手机号错误')
        return
      }
      let param = {
        subMobile: this.subMobile,
        password: this.password,
        repeatPassword: this.repeatPassword,
        nickname: this.nickname
      }
      MiniModel.addAccount(param).then(res => {
        console.log("debug:________________res______________", res);
        if (res.data.code === 200) {
          this.$message.success('新增成功')
          this.getList()
          this.dialogVisible = false
        } else {
          this.$message.error(res.data.info)
        }
      })
    },
    // 获取列表
    getList() {
      MiniModel.getAccountSub(this.searchForm).then(res => {
        if (res.data.code === 200) {
          this.searchForm.Loading = false
          this.tableList = res.data.data
        } else {
          this.$message.error(res.data.info)
        }
      })
    },
    // 改变状态
    changeSwitch(e,id){
      let param = {
        id:id,
        status:e
      }
      MiniModel.setAccountStatus(param).then(res=>{
        if (res.data.code === 200) {
          this.$message.success('设置成功')
          this.getList()
        } else {
          this.$message.error(res.data.info)
        }
      })
    },
    // 展示删除弹窗
    deleteShow(id){
      this.id = id
      this.deleteDialog = true
    },
    // 删除账号
    deleteAccount(){
      let param ={
        ids:this.id
      }
      MiniModel.deleteAccount(param).then(res=>{
        if (res.data.code === 200) {
          this.$message.success('删除成功')
          this.deleteDialog = false
          this.getList()
        } else {
          this.$message.error(res.data.info)
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.title{
  font-size: 18px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  color: #222222;
  line-height: 27px;
}
.add-button {
  width: 76px;
  height: 32px;
  background: #FF8622;
  border-radius: 2px;
  font-size: 14px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #FFFFFF;
  line-height: 32px;
  cursor: pointer;
  text-align: center;
  margin-left: auto;
  margin-bottom: 10px;
}

.input {
  width: 300px;
  height: 32px;
  background: #FFFFFF;
  border-radius: 2px;
  border: 1px solid #EEEEEE;
  padding-left: 10px;
}

.code-btn {
  height: 32px;
  border: 1px solid #EEEEEE;
  width: 100px;
  text-align: center;
  margin-left: 10px;
  line-height: 32px;
  cursor: pointer;
}
.delete{
  color: #3D9EFC;
  cursor: pointer;
}
.pagination{
  text-align: right;
  margin-top: 10px;
}
.dialog{
  width: 400px;
  margin: auto;
  .input-text{
    text-align: left;
  }
}
.flex{
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/promotion/accountNumber/index.vue